import { Button, Col, Form, FormControl, Row } from 'react-bootstrap'
import React from 'react'
import { Formik } from 'formik'
import * as Yup from 'yup'

const EnterAppAuthCodeForm = ({
    children,
    description = 'Please enter the code from your authentication app.',
    onEnteredValidCode ,
    onRescanQRCode,
    isDisabled=false,
    disableScan =false
}) => {

    const schema = Yup.object().shape({
      code: Yup.string().required("This field is required")
    });
    return (
      <React.Fragment>
        <Formik
          enableReinitialize
          validationSchema={schema}
          onSubmit={(values) => { onEnteredValidCode(values.code) }}
          initialValues={{ code: "" }}
        >
          {({
              handleSubmit,
              handleChange,
            values,
            touched,
            errors
          }) => (
            <Form
              noValidate
              onSubmit={handleSubmit}
              id="verifyCodeForm"
              autoComplete="off"
            >
              <React.Fragment>
                  { children||
                          <Row className={'mb-4'}>
                              <Col>
                                  <p className={'m-0'}>{description}</p>
                              </Col>
                          </Row>
                  }
                <Form.Row>
                  <Form.Group
                    as={Col}
                    controlId="validationPhone"
                    className="material material label-top"
                  >
                    <FormControl
                      type="text"
                      name="code"
                      value={values.code}
                      onChange={handleChange}
                      isInvalid={
                        touched.code && errors.code
                      }
                    />
                    <Form.Label>Verification code</Form.Label>
                    <Form.Control.Feedback type="invalid">
                      {errors.code}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Form.Row>
                <Row className={"my-1"}>
                  <Col className={`text-center`}>
                    <Button
                      type="submit"
                      variant="primary"
                      className={'btn-wide'}
                      disabled={isDisabled}
                    >
                      Next
                    </Button>
                    {!disableScan &&
                    <Button
                      disabled={isDisabled}
                      variant="link"
                      onClick={onRescanQRCode}>
                      Rescan QR code
                    </Button>
                    }
                  </Col>
                </Row>
              </React.Fragment>
            </Form>
          )}
        </Formik>
      </React.Fragment>
    )
  }

  export default EnterAppAuthCodeForm;
